import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import Directories from "../components/Home/Directories";
import FormHome from "../components/Home/FormHome";
import Map from "../components/Contact/MapContent";
import BaseLayout from "../components/global/BaseLayout";
import CounterUp from "../components/global/CounterUp";
import ServicesHome from "../components/Home/ContentServicesHome";
import HeroSection from "../components/Home/HeroVideo";
import Paletacolor from "../components/global/Paletacolor";
import BlockPrincipal from "../components/block/Block_12";
import BlockSecondary from "../components/block/Block_7";
import BlockAbout from "../components/block/Block_swiper";
import SlideBlock from "../components/block/SlideLogoForm";
import ModalPost from "../components/global/Post";
import VideoPromocional from "../components/global/VideoPromocional";
import ContentServices from "../components/Services/ContentServices";
import GalleryContent from "../components/Gallery/GalleryContent";
// import Modal from "../components/Home/Modal";
// import CustomReviews from "../components/reviews/CustomReviews";
// import ValuesOne from "../components/values/Values_4";

// para agregar la frase de los años de experiencia o la licencia agregar sloganPrincipal={true}
// para agregar la lista de about agregar listsAbout={true}
// para agregar la lista de servicios agregar listsServices={true}

function Home() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Home">
      <div className="md:max-w-full w-full">
        {/* <Modal /> */}
        <ModalPost/>
        <HeroSection
        urlVideo={'https://firebasestorage.googleapis.com/v0/b/imagenessanti-2a052.appspot.com/o/concrete%20video.mp4?alt=media&token=f2ec5f63-40c5-4026-a711-6f43d7b65812&_gl=1*1v6n2cx*_ga*MTg3NzIxNTgxMi4xNjczOTA2Mjk5*_ga_CW55HF8NVT*MTY5ODY5ODM5MC4yOTcuMS4xNjk4Njk4NTQzLjQ4LjAuMA..'}
          // title={rpdata?.dbSlogan?.[2]?.slogan}
          // texts={rpdata?.dbValues?.[0].description}
          // bgImg={rpdata?.stock?.[10]}
          // bgImg1={rpdata?.stock?.[4]}
          // bgImg2={rpdata?.stock?.[8]}
          // bgImg3={rpdata?.stock?.[6]}
        />

    
 <img src="https://firebasestorage.googleapis.com/v0/b/imagenessanti-2a052.appspot.com/o/EXPERIENCIA_Mesa%20de%20trabajo%2025.png?alt=media&token=90136c09-f583-4900-8941-17e3418ab1ce&_gl=1*xmbmms*_ga*MTg3NzIxNTgxMi4xNjczOTA2Mjk5*_ga_CW55HF8NVT*MTY5ODY5ODM5MC4yOTcuMS4xNjk4Njk4NDAwLjUwLjAuMA.."
      alt="sello"
    className="absolute -bottom-[200px] right-0 md:-bottom-[180px] lg:-bottom-[250px] w-[200px] md:w-[250px] lg:w-[400px]"/> 


        <BlockPrincipal
          title={rpdata?.dbSlogan?.[1]?.slogan}
          text={rpdata?.dbHome?.[0].text}
          subtitle2={'a little about us'}
          image1={rpdata?.gallery?.[4]}
          image2={rpdata?.gallery?.[6]}
          image3={rpdata?.gallery?.[7]}
          sloganPrincipal={true}
          listServices={true}
        />
        {/* video promocional */}
        {
          rpdata?.videosPromo?.[0]?.activo ?
            <VideoPromocional
              title={rpdata?.dbSlogan?.[2]?.slogan}
              text={rpdata?.dbAbout?.[1]?.text}
              linkVideo={`${rpdata?.videosPromo?.[0].link}`}
              image={`${rpdata?.videosPromo?.[0].img}`}
              vimeoVideo
            />
            : null
        }
        <SlideBlock
          title={'a little about us'}
          text={rpdata?.dbValues?.[2].description}
          image={rpdata?.gallery?.[10]}
        />
        <Directories />
        <BlockAbout
          title={'a little about us'}
          subtitle2={'a little about us'}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.gallery?.[1]}
          listsAbout={true}
        />
        {/* <ValuesOne
          image1={rpdata?.stock?.[12]}
          image2={rpdata?.stock?.[0]}
          image={rpdata?.stock?.[13]} /> */}
        <CounterUp image={rpdata?.gallery?.[3]} />
        <BlockSecondary
          title={rpdata?.dbSlogan?.[3]?.slogan}
          text={rpdata?.dbHome?.[1]?.text}
          image1={rpdata?.gallery?.[1]}
          image2={rpdata?.gallery?.[7]}
          image3={rpdata?.gallery?.[10]}
        />
        {/* our reviews */}
        {
          rpdata?.reviews?.isHomeOnly === true ?
            <div className="w-4/5 mx-auto py-[100px]">
              <h1 className="pb-10 text-center">{rpdata?.labels?.general?.titleReviews}</h1>
              <div className={`${rpdata?.reviews?.links?.[0]}`}></div>
            </div>
            : null
        }
        {/* <CustomReviews/> */}
        {/* Gallery cuando es OnePages */}
        {/* Servicios del home */}
        {
          rpdata?.simpleWidgets?.[3]?.activo ?
            <div className="pt-20">
              <ContentServices />
            </div>
            :
            <ServicesHome />
        }
        {/* Paleta de Colores */}
        {
          rpdata?.simpleWidgets?.[3]?.activo ?
            <div className="pt-10 pb-28">
              <h2 className="text-center pb-[50px]">{rpdata?.labels?.general?.titleGallery}</h2>
              <GalleryContent galleryImages={rpdata?.stock?.length > 0 ? rpdata?.stock : rpdata?.stock} />
            </div>
            :
            null
        }
        {
          rpdata?.brandingExtra?.[0]?.activo ?
            <Paletacolor />
            : null
        }
        <div
          className="bgFormHome"
          style={{ backgroundImage: `url("${rpdata?.gallery?.[8]}")` }}
        >
          <div className="relative">
            <FormHome />
          </div>
        </div>
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Home;
